import { useState } from "react"
import { apiFetch } from "../../../utils/apiFetch"

const API_BASE =
  (typeof window !== "undefined" &&
  ["localhost", "127.0.0.1", "0.0.0.0"].includes(window.location.hostname)
    ? ["http://localhost", "3000/api"].join(":")
    : "/api")

export default function usePatientOdontogramActions({
  isReadOnly,
  readOnlyReason,
  resolveSafeClinicId,
  selectedPatientId,
  selectedTooth,
  selectedSurface,
  newOdontogramCondition,
  loadPatientWorkspace,
  setSelectedSurface,
  setNewOdontogramCondition,
  setActiveTab
}) {
  const [savingOdontogram, setSavingOdontogram] = useState(false)

  const saveOdontogramEntry = async () => {
    try {
      if (isReadOnly) {
        alert(readOnlyReason || "Modo solo lectura")
        return
      }

      const currentClinicId = resolveSafeClinicId()

      if (!selectedPatientId) {
        alert("No hay paciente seleccionado.")
        return
      }

      if (!currentClinicId) {
        alert("No hay una clínica válida seleccionada.")
        return
      }

      if (!selectedTooth) {
        alert("Selecciona una pieza.")
        return
      }

      if (!newOdontogramCondition) {
        alert("Selecciona una condiciÃ³n.")
        return
      }

      const normalizedSurface = (() => {
        const raw = String(selectedSurface || "ALL").trim().toUpperCase()
        if (!raw || raw === "ALL" || raw === "TOOTH" || raw === "GENERAL") return null
        return raw
      })()

      const definitionType = normalizedSurface ? "SURFACE" : "TOOTH"

      setSavingOdontogram(true)

      const res = await apiFetch(`${API_BASE}/appointments/odontogram-entry`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          patientId: selectedPatientId,
          clinicId: currentClinicId,
          tooth: Number(selectedTooth),
          surface: normalizedSurface,
          definitionType,
          condition: String(newOdontogramCondition || "").trim().toUpperCase(),
          status: "ACTIVE"
        })
      })

      const data = await res.json().catch(() => null)

      if (!res.ok) {
        alert(data?.message || "No se pudo guardar la entrada del odontograma.")
        return
      }

      alert(
        definitionType === "TOOTH"
          ? "CondiciÃ³n general del diente registrada correctamente."
          : "CondiciÃ³n por superficie registrada correctamente."
      )

      await loadPatientWorkspace(selectedPatientId)

      setSelectedSurface("ALL")
      setNewOdontogramCondition("CARIES")
    } catch {
      alert("Error al registrar odontograma.")
    } finally {
      setSavingOdontogram(false)
    }
  }

  const sendOdontogramToPlan = () => {
    if (isReadOnly) {
      alert(readOnlyReason || "Modo solo lectura")
      return
    }

    const currentClinicId = resolveSafeClinicId()

    if (!selectedPatientId) {
      alert("No hay paciente seleccionado.")
      return
    }

    if (!currentClinicId) {
      alert("No hay una clínica válida seleccionada.")
      return
    }

    if (!selectedTooth) {
      alert("Selecciona una pieza.")
      return
    }

    if (!newOdontogramCondition) {
      alert("Selecciona una condiciÃ³n.")
      return
    }

    const normalizedSurface = (() => {
      const raw = String(selectedSurface || "ALL").trim().toUpperCase()
      if (!raw || raw === "ALL" || raw === "TOOTH" || raw === "GENERAL") return null
      return raw
    })()

    const definitionType = normalizedSurface ? "SURFACE" : "TOOTH"

    localStorage.setItem(
      "odontoflow_plan_prefill",
      JSON.stringify({
        patientId: selectedPatientId,
        clinicId: currentClinicId,
        tooth: Number(selectedTooth),
        surface: normalizedSurface,
        definitionType,
        condition: String(newOdontogramCondition || "").trim().toUpperCase()
      })
    )

    setActiveTab("PLANS")
  }

  return {
    savingOdontogram,
    saveOdontogramEntry,
    sendOdontogramToPlan
  }
}
